import type { Plugin } from '@nuxt/types';

const extendNuxtAppPlugin: Plugin = ({ app }) => {
  if (!app.mixins) {
    app.mixins = [];
  }

  app.mixins.push({
    mounted() {
      const oldABTestName = 'ab_test';

      if (app.$cookies.get(oldABTestName)) {
        app.$cookies.remove(oldABTestName);
      }
    },
  });
};

export default extendNuxtAppPlugin;
